module.exports = __webpack_public_path__ + "img/visa.8d5b4954.png";